export default __webpack_public_path__ + "static/media/avatar-6.5e8ef3d6.jpg";